import {
  createQueryParameterContext,
  QueryParameterSchema as BaseQueryParameterSchema,
  QueryParametersKey,
  QueryParametersValue,
} from '~/lib/useQueryParameter';
import { StaticProps, useStaticProps } from './StaticPropsContext';
import { schema, Parameters } from '../schema';
import { ProgramsSearchQuery } from '../data/usePrograms';

export const queryParameterContext = createQueryParameterContext<StaticProps, ProgramsSearchQuery, Parameters>(schema);

export type QueryParameterSchema<
  Key extends QueryParametersKey<Parameters>,
  Value = QueryParametersValue<Parameters, Key>,
> = BaseQueryParameterSchema<StaticProps, {}, Parameters, Key, Value>;

export function QueryParameterContext(props: { children: React.ReactNode }) {
  const staticProps = useStaticProps();
  return (
    <queryParameterContext.Provider defaultParameters={staticProps.defaultParameters} staticProps={staticProps}>
      {props.children}
    </queryParameterContext.Provider>
  );
}
